import { memo } from "react";

import { useAppUpdatePrompt } from "@/hooks/use-app-update-prompt";

// NOTE: NSAI-8170 — mounted right after each `<Sonner />` (the regular app and
// /admin/*), so the toast is raised only while a Toaster is there to show it.
// Renders nothing.
export const AppUpdateNotifier = memo((): null => {
  useAppUpdatePrompt();

  return null;
});
